var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "600px",
        transition: "dialog-bottom-transition",
        persistent: ""
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "v-form",
            {
              model: {
                value: _vm.formulario,
                callback: function($$v) {
                  _vm.formulario = $$v
                },
                expression: "formulario"
              }
            },
            [
              _c(
                "FormFieldsContainer",
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.crmBaja.label,
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.formFields.crmBaja.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.crmBaja, "value", $$v)
                              },
                              expression: "formFields.crmBaja.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.crmFecha.label,
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.formFields.crmFecha.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.crmFecha, "value", $$v)
                              },
                              expression: "formFields.crmFecha.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.cliente.label,
                              items: _vm.clientes,
                              "item-text": "nombre",
                              "item-value": "id",
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.formFields.cliente.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.cliente, "value", $$v)
                              },
                              expression: "formFields.cliente.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.equipos.label,
                              rules: [_vm.rules.negativo],
                              type: "number"
                            },
                            model: {
                              value: _vm.formFields.equipos.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.equipos, "value", $$v)
                              },
                              expression: "formFields.equipos.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.perifericos.label,
                              rules: [_vm.rules.negativo],
                              type: "number"
                            },
                            model: {
                              value: _vm.formFields.perifericos.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.perifericos,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.perifericos.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: { label: _vm.formFields.autor.label },
                            model: {
                              value: _vm.formFields.autor.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.autor, "value", $$v)
                              },
                              expression: "formFields.autor.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: _vm.formFields.concepto.label,
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.formFields.concepto.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.concepto, "value", $$v)
                              },
                              expression: "formFields.concepto.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs6: "", sm6: "", md7: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md5: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          attrs: { disabled: !_vm.formulario },
                          on: {
                            click: function($event) {
                              return _vm.crearCliente()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }